/* eslint-disable @typescript-eslint/no-explicit-any */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import { CDN_URL, DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "./constants";

import enUS from "./locales/en-US-web.json";
import esES from "./locales/es-ES-web.json";
import frCA from "./locales/fr-CA-web.json";

const localResources: Record<string, typeof enUS> = {
  "en-US": enUS,
  "es-ES": esES,
  "fr-CA": frCA,
};

const useLocalTranslations =
  process.env.NODE_ENV === "development" ||
  process.env.REACT_APP_ENV === "staging";

const getCdnUrl = (lng: string) => `${CDN_URL}/${lng}-web.json`;

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    ns: ["translation"],
    defaultNS: "translation",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "lang",
    },
    backend: {
      loadPath: "{{lng}}",
      request: async (
        _options: any,
        url: any,
        _payload: any,
        callback: any,
      ) => {
        const localFile = localResources[url];

        if (useLocalTranslations && localFile) {
          console.log("Using local translation files");
          callback(null, { status: 200, data: localFile });
          return;
        }

        try {
          const res = await fetch(getCdnUrl(url));
          const data = await res.json();
          console.log("Using CDN files");
          callback(null, {
            status: res.status,
            data: localFile ? { ...localFile, ...data } : data,
          });
          return;
        } catch (err) {
          if (localFile) {
            console.log("CDN Failed: Using local files");
            callback(null, { status: 200, data: localFile });
            return;
          }
          console.error("[i18n] Error loading translation:", err);
          callback(err as any, { status: 500 });
        }
      },
    },
  });

export default i18n;
